export default "__VITE_ASSET__C9FMF6Ak__"